
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      $$('#bloodBankPage .add-patient-btn').on('click', function (e) {
        e.preventDefault();
        app.popup.open('#addPatientPopup');
      });
      $$('#saveNewPatient').on('click', function () {
        var name = $$('#newPatientName').val().trim();
        var age = $$('#newPatientAge').val().trim();
        var gender = $$('#addPatientPopup input[name="new_patient_gender"]:checked').val();
        if (!name || !age) {
          app.dialog.alert('Please fill all patient details');
          return;
        }
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'patients',
          method: 'POST',
          data: {
            name: name,
            age: age,
            gender: gender
          },
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status) {
              var patient = response.data;
              var patientHtml = '<div class="item-input-wrap patient-radio-item">' + '<label class="radio">' + '<input type="radio" name="patient_id" value="' + patient.id + '" checked="">' + '<i class="icon-radio"></i>' + '</label>' + '<span class="patient-info"> ' + patient.name + ' / ' + patient.gender + ' / ' + patient.age + ' yrs</span>' + '</div>';
              $$('#bloodBankPage input[name="patient_id"]').prop('checked', false);
              $$('#bloodBankPage .no-patients-text').remove();
              $$('#bloodBankPage .add-patient-btn').parent().before(patientHtml);
              app.popup.close('#addPatientPopup');
              $$('#newPatientName').val('');
              $$('#newPatientAge').val('');
              $$('#addPatientPopup input[name="new_patient_gender"][value="Male"]').prop('checked', true);
              app.dialog.alert('Patient added successfully', 'Success');
            } else {
              var errorMsg = response.msg || 'Failed to add patient';
              if (response.errors) {
                var msgs = [];
                Object.keys(response.errors).forEach(function (key) {
                  msgs.push(response.errors[key].join(', '));
                });
                errorMsg = msgs.join('\n');
              }
              app.dialog.alert(errorMsg, 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
      app.stepper.create({
        el: '#unitsStepper',
        min: 1,
        max: 10,
        step: 1,
        value: 1,
        wraps: false,
        formatValue: function (value) {
          return value;
        }
      });
      $$('#prescriptionDropArea').on('click', function (e) {
        if (!$$(e.target).closest('#removeFileBtn').length) {
          $$('#prescriptionFile').click();
        }
      });
      $$('#prescriptionFile').on('change', function () {
        var file = this.files[0];
        if (file) {
          $$('#uploadPlaceholder').hide();
          $$('#uploadPreview').show();
          $$('#previewFileName').text(file.name);
          if (file.type.startsWith('image/')) {
            var reader = new FileReader();
            reader.onload = function (e) {
              $$('#previewImage').attr('src', e.target.result).show();
              $$('#previewFileIcon').hide();
            };
            reader.readAsDataURL(file);
          } else {
            $$('#previewImage').hide();
            $$('#previewFileIcon').show();
          }
        }
      });
      $$('#removeFileBtn').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $$('#prescriptionFile').val('');
        $$('#uploadPreview').hide();
        $$('#uploadPlaceholder').show();
        $$('#previewImage').attr('src', '').hide();
        $$('#previewFileIcon').show();
      });
      $$('#bloodBankForm').on('submit', function (e) {
        e.preventDefault();
        var selectedPatient = $$('#bloodBankPage input[name="patient_id"]:checked').val();
        if (!selectedPatient) {
          app.dialog.alert('Please select a patient');
          return;
        }
        var bloodGroup = $$('#bloodBankPage input[name="blood_group"]:checked').val();
        if (!bloodGroup) {
          app.dialog.alert('Please select a blood group');
          return;
        }
        var formData = {
          patient_id: selectedPatient,
          blood_group: bloodGroup,
          units: parseInt($$('#unitsInput').val()) || 1
        };
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'blood-bank-requests',
          method: 'POST',
          data: formData,
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status) {
              app.dialog.alert(response.msg, 'Success', function () {
                app.views.main.router.navigate('/home/');
              });
            } else {
              app.dialog.alert(response.msg, 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
    }
  },
  id: 'ad343ce9ae',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="blood-bank" id="bloodBankPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Blood Bank</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <form id="bloodBankForm">\n\n                <!--patient details section-->\n                <div class="card booking">\n                    <div class="card-content ptnt">\n                        <div class="content-header">Patient</div>\n                        <div class="card-content" id="patientListArea">\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.patientList.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.patientList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="item-input-wrap patient-radio-item">\n                                <label class="radio">\n                                    <input type="radio" name="patient_id" value="';
              r += c(ctx_3.id, ctx_3);
              r += '" ';
              r += Template7Helpers.if.call(ctx_3, data_3 && data_3.first, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'checked=""';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '>\n                                    <i class="icon-radio"></i>\n                                </label>\n                                <span class="patient-info"> ';
              r += c(ctx_3.name, ctx_3);
              r += ' / ';
              r += c(ctx_3.gender, ctx_3);
              r += ' / ';
              r += c(ctx_3.age, ctx_3);
              r += ' yrs</span>\n                            </div>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <p class="no-patients-text">No patients added yet. Add a patient to continue.</p>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            <div style="margin-top: 10px;">\n                                <a href="#" class="link add-patient-btn" style="color: #1F8F60; font-weight: 600;">+ Add New Patient</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!--blood group section as grid radio buttons-->\n                <div class="card booking">\n                    <div class="card-content ptnt">\n                        <div class="content-header"><sup class="requiredAst">*</sup> Select Blood Group</div>\n                        <div class="card-content">\n                            <div class="blood-group-grid">\n                                <div class="row">\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="A+">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">A+</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="A-">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">A-</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="B+">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">B+</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="B-">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">B-</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                </div>\n                                <div class="row" style="margin-top: 10px;">\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="O+">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">O+</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="O-">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">O-</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="AB+">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">AB+</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class="col-25">\n                                        <label class="blood-group-item">\n                                            <input type="radio" name="blood_group" value="AB-">\n                                            <div class="blood-group-box">\n                                                <span class="blood-type">AB-</span>\n                                            </div>\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!--units section-->\n                <div class="card booking">\n                    <div class="card-content ptnt">\n                        <div class="content-header"><sup class="requiredAst">*</sup> Units Required</div>\n                        <div class="card-content">\n                            <div class="units-stepper-wrap">\n                                <div class="stepper stepper-fill stepper-large color-pink" id="unitsStepper">\n                                    <div class="stepper-button-minus"></div>\n                                    <div class="stepper-input-wrap">\n                                        <input type="text" name="units" id="unitsInput" value="1" min="1" max="10" readonly>\n                                    </div>\n                                    <div class="stepper-button-plus"></div>\n                                </div>\n                                <p class="units-hint">Min: 1 | Max: 10 units</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!--prescription upload section-->\n                <div class="card booking">\n                    <div class="card-content ptnt">\n                        <div class="content-header">Prescription (Optional)</div>\n                        <div class="card-content">\n                            <div class="prescription-upload-area" id="prescriptionDropArea">\n                                <div class="upload-placeholder" id="uploadPlaceholder">\n                                    <div class="upload-icon">\n                                        <i class="material-icons" style="font-size: 42px; color: #2EB67D;">cloud_upload</i>\n                                    </div>\n                                    <p class="upload-text">Tap to upload prescription</p>\n                                    <p class="upload-hint">Supports JPG, PNG, PDF</p>\n                                </div>\n                                <div class="upload-preview" id="uploadPreview" style="display: none;">\n                                    <div class="preview-content">\n                                        <i class="material-icons preview-icon" id="previewFileIcon" style="font-size: 36px; color: #4CAF50;">insert_drive_file</i>\n                                        <img id="previewImage" src="" style="display: none; max-width: 100%; max-height: 120px; border-radius: 8px;">\n                                        <p class="preview-filename" id="previewFileName"></p>\n                                    </div>\n                                    <a href="#" class="link remove-file-btn" id="removeFileBtn">\n                                        <i class="material-icons" style="color: #ff3b30;">close</i>\n                                    </a>\n                                </div>\n                                <input type="file" name="prescription" id="prescriptionFile" accept="image/*,.pdf" style="display: none;">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!--submit button-->\n                <div class="block">\n                    <button class="button button-fill button-large" type="submit">Submit Request</button>\n                </div>\n            </form>\n        </div>\n\n        <!-- Add New Patient Popup -->\n        <div class="popup" id="addPatientPopup">\n            <div class="view">\n                <div class="page">\n                    <div class="navbar">\n                        <div class="navbar-inner">\n                            <div class="left">\n                                <a href="#" class="link popup-close" style="color: #1F8F60;">\n                                    <i class="icon icon-back"></i>\n                                </a>\n                            </div>\n                            <div class="title">Add New Patient</div>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                        <div class="list inline-labels no-hairlines-md" style="margin-top: 10px;">\n                            <ul>\n                                <li class="item-content item-input">\n                                    <div class="item-inner">\n                                        <div class="item-title item-label"><sup class="requiredAst">*</sup>Name</div>\n                                        <div class="item-input-wrap">\n                                            <input type="text" placeholder="Patient name" value="" id="newPatientName">\n                                            <span class="input-clear-button"></span>\n                                        </div>\n                                    </div>\n                                </li>\n                                <li class="item-content item-input">\n                                    <div class="item-inner">\n                                        <div class="item-title item-label"><sup class="requiredAst">*</sup>Age</div>\n                                        <div class="item-input-wrap">\n                                            <input type="number" placeholder="Age" id="newPatientAge" pattern="[0-9]*">\n                                            <span class="input-clear-button"></span>\n                                        </div>\n                                    </div>\n                                </li>\n                                <li class="item-content item-input d-none-after">\n                                    <div class="item-inner">\n                                        <div class="item-title item-label"><sup class="requiredAst">*</sup>Gender</div>\n                                        <div class="item-input-wrap">\n                                            <label class="radio">\n                                                <input type="radio" checked="" name="new_patient_gender" value="Male">\n                                                <i class="icon-radio"></i>\n                                            </label>\n                                            <span>Male</span>\n                                            <label class="radio">\n                                                <input type="radio" name="new_patient_gender" value="Female">\n                                                <i class="icon-radio"></i>\n                                            </label>\n                                            <span>Female</span>\n                                            <label class="radio">\n                                                <input type="radio" name="new_patient_gender" value="Other">\n                                                <i class="icon-radio"></i>\n                                            </label>\n                                            <span>Others</span>\n                                        </div>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div>\n                        <div class="block">\n                            <button class="button button-fill button-large" type="button" id="saveNewPatient">Save Patient</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    /* Patient Radio List */
[data-f7-ad343ce9ae] .patient-radio-item {
        padding: 10px 0;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
    }
[data-f7-ad343ce9ae] .patient-radio-item:last-of-type {
        border-bottom: none;
    }
[data-f7-ad343ce9ae] .patient-info {
        font-size: 15px;
        color: #333;
        margin-left: 4px;
    }
[data-f7-ad343ce9ae] .no-patients-text {
        font-size: 14px;
        color: #999;
        text-align: center;
        padding: 15px 0;
    }

    /* Blood Group Grid */
[data-f7-ad343ce9ae] .blood-group-grid {
        padding: 5px 0;
    }
[data-f7-ad343ce9ae] .blood-group-item {
        display: block;
        cursor: pointer;
    }
[data-f7-ad343ce9ae] .blood-group-item input[type="radio"] {
        display: none;
    }
[data-f7-ad343ce9ae] .blood-group-box {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        border: 2px solid #e0e0e0;
        border-radius: 10px;
        background: #fff;
        transition: all 0.2s ease;
    }
[data-f7-ad343ce9ae] .blood-group-item input[type="radio"]:checked + .blood-group-box {
        border-color: #2EB67D;
        background: linear-gradient(135deg, #E7F6EF, #fff);
        box-shadow: 0 2px 8px rgba(46, 182, 125, 0.2);
    }
[data-f7-ad343ce9ae] .blood-type {
        font-size: 18px;
        font-weight: 700;
        color: #333;
    }
[data-f7-ad343ce9ae] .blood-group-item input[type="radio"]:checked + .blood-group-box .blood-type {
        color: #1F8F60;
    }

    /* Prescription Upload Area */
[data-f7-ad343ce9ae] .prescription-upload-area {
        border: 2px dashed #d0d0d0;
        border-radius: 12px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #fafafa;
        position: relative;
        min-height: 100px;
    }
[data-f7-ad343ce9ae] .prescription-upload-area:active {
        border-color: #2EB67D;
        background: #E7F6EF;
    }
[data-f7-ad343ce9ae] .upload-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
    }
[data-f7-ad343ce9ae] .upload-text {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        margin: 0;
    }
[data-f7-ad343ce9ae] .upload-hint {
        font-size: 12px;
        color: #999;
        margin: 0;
    }
[data-f7-ad343ce9ae] .upload-preview {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    }
[data-f7-ad343ce9ae] .preview-content {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;
        min-width: 0;
    }
[data-f7-ad343ce9ae] .preview-filename {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
[data-f7-ad343ce9ae] .remove-file-btn {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f5f5;
        border-radius: 50%;
        flex-shrink: 0;
    }

    /* Units Stepper */
[data-f7-ad343ce9ae] .units-stepper-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 0;
    }
[data-f7-ad343ce9ae] .units-stepper-wrap .stepper {
        max-width: 200px;
    }
[data-f7-ad343ce9ae] .units-hint {
        font-size: 12px;
        color: #999;
        margin: 8px 0 0;
    }
`,
  styleScoped: true
};
    